import { authAxios } from "services";

export const fetchAll = (page, searchParams = {}) => {
  const urlParams = new URLSearchParams();
  urlParams.append("page", page);

  Object.keys(searchParams).forEach((key) => {
    if (searchParams[key]) {
      urlParams.append(key, searchParams[key]);
    }
  });

  return authAxios().get(`/users?${urlParams.toString()}`);
};

export const create = (data) => authAxios().post(`/users`, data);

export const fetchById = (id) => authAxios().get(`/users/${id}`);

export const deleteById = (id) => authAxios().delete(`/users/${id}`);

export const updateById = (id, data) => authAxios().post(`/users/${id}?_method=PUT`, data);

export const updatePasswordById = (id, data) => authAxios().post(`/users/${id}/password`, data);
